// src/agents/CompanyCustomersPage.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Sidebar from "../components/Sidebar";
import { showError, showSuccess } from "../utils/toast"; // adjust path


const CompanyCustomersPage = () => {
  const { companyName } = useParams();
  const {policyType} = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();

  const [customers, setCustomers] = useState([]); // kept (unused)
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [policies, setPolicies] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [selectedType, setSelectedType] = useState("All");
  const [selectedCompany, setSelectedCompany] = useState("All");

  const insuranceOptions = {
    "Life Insurance": [
      "Term Insurance ",
      "Whole Life Insurance",
      "Endowment Insurance",
      "Money-Back Insurance",
      "ULIP Insurance",
      "Child Insurance",
      "Pension Insurance",
    ],
    "General Insurance": [
      "Health Insurance",
      "Motor Insurance",
      "Travel Insurance",
      "Home Insurance",
      "Fire Insurance",
      "Marine Insurance",
      "Personal Accident Insurance",
      "Commercial Insurance",
    ],
  };

  const toggleSidebar = () => setSidebarOpen((s) => !s);

  useEffect(() => {
    const fetchPolicies = async () => {
      try {
        const agent = user || JSON.parse(localStorage.getItem("user"));
        const agentId = agent?.id || user?.id;
        if (!agentId || !companyName) return;

        const decodedCompany = decodeURIComponent(companyName).trim();

        const url = policyType && policyType !== "All"
          ? `${import.meta.env.VITE_API_URL}/api/policies?company=${encodeURIComponent(companyName)}&agentId=${agentId}&policyType=${encodeURIComponent(policyType)}`
          : `${import.meta.env.VITE_API_URL}/api/policies?company=${encodeURIComponent(companyName)}&agentId=${agentId}`;
        const res = await fetch(url);
        const data = await res.json();
        if (Array.isArray(data.policies)) setPolicies(data.policies);
      } catch (error) {
        console.error("Error fetching policies:", error);
      }
    };

    fetchPolicies();
  }, [companyName, user]);

  const getAgeFromDOB = (dob) => {
    if (!dob) return "--";
    try {
      const birth = new Date(dob);
      if (isNaN(birth)) return "--";
      const today = new Date();
      let age = today.getFullYear() - birth.getFullYear();
      const m = today.getMonth() - birth.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
      return age;
    } catch {
      return "--";
    }
  };

  const formatDate = (dateValue) => {
    try {
      const date = new Date(dateValue);
      if (!isNaN(date.getTime())) return date.toISOString().split("T")[0];
    } catch {}
    return "--";
  };

  const formatINR = (n) =>
    `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

  const handleDeleteCustomer = async (policyId, index) => {
    if (!window.confirm("Are you sure you want to delete this policy?")) return;
    try {
      const res = await fetch(`${import.meta.env.VITE_API_URL}/api/policies/${policyId}`, {
        method: "DELETE",
      });
      const data = await res.json();
      if (res.ok) {
        const updated = [...policies];
        updated.splice(index, 1);
        setPolicies(updated);
        alert("✅ Policy deleted successfully!");
      } else {
        alert("❌ " + (data.msg || "Delete failed"));
      }
    } catch (err) {
      console.error("Delete error:", err);
      alert("❌ Server error");
    }
  };

  // Get unique insurance types from policies
  const getAvailableInsuranceTypes = () => {
    const types = new Set();
    policies.forEach(p => {
      if (p.policyType) {
        types.add(p.policyType);
      }
    });
    return Array.from(types).sort();
  };

  const availableTypes = getAvailableInsuranceTypes();

  const filteredPolicies = policies.filter((p) => {
    const nameMatch = p.customerName
      ?.toLowerCase()
      .includes(searchTerm.toLowerCase());
    const numberMatch = p.policyNumber?.toString().includes(searchTerm);
    const categoryMatch =
      selectedCategory === "All" || p.policyType === selectedCategory;
    const typeMatch =
      selectedType === "All" ||
      p.policyType === selectedType;
    return (nameMatch || numberMatch) && categoryMatch && typeMatch;
  });

  const companyPretty = decodeURIComponent(companyName || "");

  return (
    <div className="dashboard-layout d-flex">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <div className="main-content flex-grow-1 company-customers-compact">
        <div className="container py-4">

          {/* top bar */}
          <div className="ccc-topbar">
            
            {/* header */}
            <div className="ccc-head">
              <h1>{companyPretty}</h1>
              <p>Manage all your customers and their insurance policies.</p>
            </div>

            <div className="h__container gx-4">

              <button className="ccc-back" onClick={() => navigate(-1)}>
                <i className="bi bi-arrow-left" />
                <span>Back to Companies</span>
              </button>

              <button
                className="ccc-add blue__btn "
                onClick={() => navigate("/agent/company-selection")}
              >
                <i className="bi bi-plus-lg" />
                <span>Add Customer</span>
              </button>
            </div>
          </div>

          

          {/* filters */}
          <div className="ccc-filters card border-0 shadow-sm">
            <div className="card-body">
              <div className="row g-3 align-items-center">
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="input-group input-group-lg">
                    <span className="input-group-text">
                      <i className="bi bi-search" />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by Name / Number"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>

                

                <div className="col-6 col-md-3 col-lg-3">
                  <div className="ccc-select">
                    <select
                      className="form-select form-select-lg"
                      value={selectedType}
                      onChange={(e) => setSelectedType(e.target.value)}
                    >
                      <option value="All">All Types</option>
                      {availableTypes.map((type) => (
                        <option key={type} value={type}>
                          {type}
                        </option>
                      ))}
                    </select>
                    <i className="bi bi-chevron-down" />
                  </div>
                </div>


                <div className="col-12 col-lg-2">
                  <button
                    className="btn btn-outline-danger w-100"
                    onClick={() => {
                      setSearchTerm("");
                      setSelectedCompany("All");
                      setSelectedCategory("All");
                      setSelectedType("All");
                    }}
                  >
                    <i className="bi bi-x-circle me-1" />
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>

         {/* table / responsive cards */}
          {filteredPolicies.length === 0 ? (
            <div className="text-muted text-center py-5">No policies found.</div>
          ) : (
            <div className="card border-0 shadow-sm">
              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table ccc-table table-hover align-middle mb-0">
                    <thead>
                      <tr>
                        <th>S.N</th>
                        <th>Customer</th>
                        <th>Contact</th>
                        <th>Policy No.</th>
                        <th>Insurance</th>
                        <th>Premium</th>
                        <th>Next Due</th>
                        <th className="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredPolicies.map((p, idx) => {
                        const dob = p.customerDOB || null;
                        return (
                          <tr key={idx}>
                            <td className="ccc-idx">{idx + 1}</td>

                            <td className="ccc-customer">
                              <div className="name">{p.customerName || "N/A"}</div>
                              <div className="meta">
                                Age: {getAgeFromDOB(dob)} • <br /> DOB: {formatDate(dob)}
                              </div>
                            </td>

                            <td className="ccc-contact">
                              <div>{p.customerPhone || "N/A"}</div>
                              <div className="muted">{p.customerEmail || "N/A"}</div>
                            </td>

                            <td className="ccc-policy">{p.policyNumber || "N/A"}</td>
                            <td className="ccc-wrap">{p.policyType || "N/A"}</td>
                            <td className="ccc-money">{formatINR(p.policyDetails?.premium)}</td>
                            <td className="ccc-nowrap">{formatDate(p.policyDetails?.endDate)}</td>

                            <td className="text-center">
                              <div className="ccc-actions">
                                <button
                                  className="icon"
                                  onClick={() => navigate(`/agent/customer/${p._id || 0}`)}
                                  title="View"
                                >
                                  <i className="bi bi-eye" />
                                </button>
                                <button
                                  className="icon danger"
                                  onClick={() => handleDeleteCustomer(p._id, idx)}
                                  title="Delete"
                                >
                                  <i className="bi bi-trash" />
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

        </div>
                <div className="ccc-foot">
                  <div className="muted">Showing {filteredPolicies.length} of {filteredPolicies.length} customers</div>
                  <ul className="pagination mb-0">
                    <li className="page-item disabled"><button className="page-link">Previous</button></li>
                    <li className="page-item active"><button className="page-link">1</button></li>
                    <li className="page-item"><button className="page-link">Next</button></li>
                  </ul>
                </div>
      </div>
    </div>
  );
};

export default CompanyCustomersPage;